import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "./Renew.module.css";
import Navbar from "../../components/ui/Navbar";
import Footer from "../../components/ui/Footer";
// import { useNavigate } from "react-router";
import Menu from "../../components/ui/Menu";
import FixedAgent from "../../utils/api/FixedAgent";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router";
import { userDataActions } from "../../store/redux-store/Index";
import { NICON_PRODUCT_CATALOGUE } from "../../utils/constants/vehicleData";
import {
  PRIVATE_MOTOR_COMMERCIAL_WARNING,
  shouldBlockPrivateMotorPlate,
} from "../../utils/privateMotorPlateGuard";
import { mergeVehicleInfo } from "../../utils/vehicleInfo";
// import { userDataActions } from "../../store/redux-store/Index";

function Renew(props) {
  const [modalOpen, setModalOpen] = useState(false);
  const [productsDetails, setProductsDetails] = useState(null);
  const [plateNumber, setPlateNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [insuranceType, setInsuranceType] = useState("");
  const [updateMessage, setUpdateMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSkipButton, setShowSkipButton] = useState(false);
  const abortControllerRef = useRef(null);
  const skipTimerRef = useRef(null);

  const token = useSelector((state) => state.userData.loginData.token);
  const accountType = useSelector(
    (state) => state.userData.loginData.account_type,
  );
  const agMeta = useSelector((state) => state.userData.agMeta);
  const isPrivateMotorPlateBlocked = shouldBlockPrivateMotorPlate({
    insuranceType,
    product: productsDetails,
    plateNumber,
  });

  // const cartCallBack = useCallback(() => {
  //   const fetchCartHistory = async () => {
  //     try {
  //       setIsLoading(true);
  //       const productsListRes = await FixedAgent.getManualCartList({
  //         token,
  //       });
  //       setCartList(productsListRes.data.data);
  //       setIsLoading(false);
  //     } catch (err) {
  //       setIsLoading(false);
  //       toast.error(err?.response?.data?.message, {
  //         position: "top-left",
  //         autoClose: 5000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //         theme: "dark",
  //       });
  //     }
  //   };
  //   fetchCartHistory();
  // }, [token]);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const userDetails = useSelector((state) => state.userData.personalInfo);

  // useEffect(() => {
  //   const fetchVehicleModels = async () => {
  //     try {
  //       if (vehicleMake) {
  //         setIsLoading(true);
  //         const vehicleModelsRes = await FixedAgent.getVehicleModelsByID({
  //           id: vehicleMake,
  //           token,
  //         });
  //         setVehicleModel(vehicleModelsRes.data.modelToReturn);
  //         setIsLoading(false);
  //       }
  //     } catch (err) {
  //       setIsLoading(false);
  //       toast.error(err?.response?.data?.message, {
  //         position: "top-left",
  //         autoClose: 5000,
  //         hideProgressBar: true,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: false,
  //         progress: undefined,
  //         style: {
  //           backgroundColor: "#FFFFFF",
  //           color: "#000000",
  //         },
  //       });
  //     }
  //   };

  //   fetchVehicleModels();
  // }, [vehicleMake, token]);

  // useEffect(() => {
  //   const fetchVehicleColors = async () => {
  //     try {
  //       setIsLoading(true);
  //       const vehicleColorsRes = await FixedAgent.getVehicleColours({
  //         token,
  //       });
  //       setVehicleColor(vehicleColorsRes.data.modelToReturn);
  //       setIsLoading(false);
  //     } catch (err) {
  //       setIsLoading(false);
  //       toast.error(err?.response?.data?.message, {
  //         position: "top-left",
  //         autoClose: 5000,
  //         hideProgressBar: true,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: false,
  //         progress: undefined,
  //         style: {
  //           backgroundColor: "#FFFFFF",
  //           color: "#000000",
  //         },
  //       });
  //     }
  //   };

  //   fetchVehicleColors();
  // }, [token]);

  // Removed dynamic product fetch logic

  // const getUserData = async (product) => {
  //   // let orderData = [];
  //   // orderData.push(productsDetails);
  //   try {
  //     const addToCartRes = await FixedAgent.addToCart({
  //       product_id: product?.id,
  //       token,
  //     });
  //     toast.success(addToCartRes?.data?.message, {
  //       position: "top-left",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "dark",
  //     });
  //     // cartCallBack();
  //     // const userReq = await FixedAgent.getCustomerByPlateNumber({
  //     //   plate_no: plateNumber,
  //     //   token,
  //     // });

  //     // if (userReq.data.data === null) {
  //     //   const onlineUserReq = await FixedAgent.getCustomerOnlineData({
  //     //     plate_no: plateNumber,
  //     //     token,
  //     //   });
  //     //   orderData.push(onlineUserReq.data.data);
  //     // } else {
  //     //   orderData.push(userReq.data.data);
  //     // }

  //     // dispatch(userDataActions.getRenewPapersData(orderData));
  //     // navigate("/renew/info");
  //   } catch (err) {
  //     toast.error(err?.response?.data?.message, {
  //       position: "top-left",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "dark",
  //     });
  //   }
  // };

  const handleRenew = (products) => {
    setProductsDetails(products);
    setModalOpen(true);
  };

  // Removed legacy filter and special pin effects

  useEffect(() => {
    const fetchAgMeta = async () => {
      const hasAgMetaData = Boolean(
        agMeta.data?.source === "combined-form-data" &&
          agMeta.data?.vehicleMakeModels?.length &&
          agMeta.data?.colors?.length &&
          agMeta.data?.years?.length &&
          agMeta.data?.vehicleTypes?.length &&
          agMeta.data?.types?.length &&
          agMeta.data?.agpMakes?.length &&
          agMeta.data?.agpModels?.length &&
          agMeta.data?.agpVehicleTypes?.length &&
          agMeta.data?.agpTypes?.length,
      );

      if (
        !["AG", "AGP"].includes(insuranceType) ||
        accountType === "DISTRIBUTOR" ||
        !token ||
        agMeta.loading ||
        hasAgMetaData
      ) {
        return;
      }

      try {
        dispatch(userDataActions.setAgMetaLoading(true));
        const response = await FixedAgent.getAGMetadata({ token });
        const combinedAgData = response.data?.data || {};
        const niipData = combinedAgData.niip || {};
        const agpData = combinedAgData.agp || {};

        dispatch(
          userDataActions.setAgMetaData({
            source: "combined-form-data",
            // AG submits the NIIP combined make/model identifier.
            vehicleMakeModels: niipData.vehicle_make_model || [],
            engineCapacities: niipData.engine_capacity || [],
            colors: (niipData.vehicle_colour || []).map((color) => ({
              ...color,
              vehicleColorId: color.id,
              colorName: color.name,
            })),
            years: niipData.vehicle_years || [],
            stateLga: niipData.state_lga || [],
            vehicleTypes: niipData.vehicle_types || [],
            types: niipData.types || [],
            // AGP submits independent make and model identifiers.
            agpMakes: agpData.makes || [],
            agpModels: agpData.models || [],
            agpColors: (agpData.colors || []).map((color) => ({
              ...color,
              vehicleColorId: color.id,
              colorName: color.name,
            })),
            agpYears: agpData.vehicle_years || agpData.years || [],
            agpVehicleTypes: agpData.vehicle_types || [],
            agpTypes: agpData.types || [],
          }),
        );
      } catch (error) {
        dispatch(
          userDataActions.setAgMetaError(
            error?.response?.data?.message ||
              error?.message ||
              "Failed to load AG form data",
          ),
        );
        toast.error(
          error?.response?.data?.message || "Failed to load AG form data",
          {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            style: {
              backgroundColor: "#FFFFFF",
              color: "#000000",
            },
          },
        );
      }
    };

    fetchAgMeta();
  }, [
    insuranceType,
    accountType,
    token,
    dispatch,
    agMeta.data,
    agMeta.loading,
  ]);

  const fetchUserSecondInsuranceData = useCallback(
    async (plate_no) => {
      try {
        setUpdateMessage("Fetching Your Insurance Data");

        const getUserSecondInsuranceRes =
          await FixedAgent.getCustomerInsuranceOnlineData({
            plate_no,
            token,
          });
        setUpdateMessage("Insurance Data Fetched");

        setUpdateMessage("Fetching Your Road Data");

        const getUserRoadRes = await FixedAgent.getRoadData({
          plate_no: plate_no,
          token,
        });

        setUpdateMessage("Road Data Fetched");

        setUpdateMessage("Adding new customer");

        const addNewUser = await FixedAgent.addNewCustomer({
          phone_no: "0" + userDetails?.phone_no,
          plate_no: plateNumber,
          fullname: getUserSecondInsuranceRes.data?.data?.full_name,
          token: token,
          engine_number: getUserSecondInsuranceRes.data?.data?.engine_no,
          chassis: getUserSecondInsuranceRes.data?.data?.chassis_no,
          make: getUserSecondInsuranceRes.data?.data?.make,
          model: getUserSecondInsuranceRes.data?.data?.model,
          year: getUserSecondInsuranceRes.data?.data?.year,
          road_expiry_date: getUserRoadRes.data.data.RwcExp,
          road_message: getUserRoadRes.data.data.message,
          color: getUserSecondInsuranceRes.data?.data?.color,
          state: "lagos",
        });
        setUpdateMessage("Customer Added");

        setIsLoading(false);
        setUpdateMessage("");

        return addNewUser;
      } catch (err) {
        setIsLoading(false);

        if (err?.response?.data?.message === "Unauthenticated") {
          dispatch(userDataActions.logout());
          window.location.reload();
        }
        if (
          err?.response?.data?.message ===
          "Policy details are invalid or not matching."
        ) {
          setUpdateMessage("Redirecting to manual add");
          dispatch(userDataActions.setUserPlateNumber(plateNumber));
          setIsLoading(true);
          navigate("/add-customer");
          setUpdateMessage("");
        } else {
          toast.error(err?.response?.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            style: {
              backgroundColor: "#FFFFFF",
              color: "#000000",
            },
          });
        }
      }
    },
    [token, dispatch, plateNumber, navigate, userDetails?.phone_no],
  );

  const addCustomerHandler = async () => {
    try {
      setLoading(true);
      setUpdateMessage("Fetching Your Road Data");
      const getUserRoadRes = await FixedAgent.getRoadData({
        plate_no: plateNumber,
        token,
      });
      setUpdateMessage("Road Data Fetched");

      // const getUserVehicleInfo = await FixedAgent.getCustomerOnlineData({
      //   plate_no: plateNumber,
      //   token,
      // });
      // let insuranceData;
      // if (getUserVehicleInfo.data.data.VehicleMake === "") {
      setUpdateMessage("Fetching Your Insurance Data");

      const getUserInsuranceRes =
        await FixedAgent.getCustomerInsuranceSecondOnlineData({
          plate_no: plateNumber,
          token,
        });
      setUpdateMessage("Insurance Data Fetched");

      // insuranceData = getUserInsuranceRes.data;
      // }
      setUpdateMessage("Adding Customer");

      const addNewUser = await FixedAgent.addNewCustomer({
        phone_no: "0" + userDetails?.phone_no,
        plate_no: plateNumber,
        fullname: getUserInsuranceRes.data?.data?.full_name,
        token: token,
        engine_number: getUserInsuranceRes.data?.data?.engine_no,
        chassis: getUserInsuranceRes.data?.data?.chassis_no,
        make: getUserInsuranceRes.data?.data?.make,
        model: getUserInsuranceRes.data?.data?.model,
        year: getUserInsuranceRes.data?.data?.year,
        road_expiry_date: getUserRoadRes.data.data.RwcExp,
        road_message: getUserRoadRes.data.data.message,
        color: getUserInsuranceRes.data?.data?.color,
        state: "lagos",
      });
      setUpdateMessage("Customer Added");

      submitOrderHandler();

      toast.success(`Successfull`, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        style: {
          backgroundColor: "#FFFFFF",
          color: "#000000",
        },
      });
      setUpdateMessage("");

      navigate("/renew");

      setLoading(false);

      return addNewUser;
    } catch (err) {
      setLoading(false);

      if (
        err?.response?.data?.message ===
        "Policy details are invalid or not matching."
      ) {
        setIsLoading(true);
        fetchUserSecondInsuranceData(plateNumber);
      } else {
        toast.error(err?.response?.data?.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          style: {
            backgroundColor: "#FFFFFF",
            color: "#000000",
          },
        });
      }

      if (err?.response?.data?.message === "Unauthenticated") {
        dispatch(userDataActions.logout());
        window.location.reload();
      }
    }
  };

  const handleSkipAutofill = () => {
    // Abort the in-flight API call
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }
    // Clear the skip timer
    if (skipTimerRef.current) {
      clearTimeout(skipTimerRef.current);
      skipTimerRef.current = null;
    }

    setLoading(false);
    setShowSkipButton(false);
    setUpdateMessage("");

    // Navigate to renew/info with empty vehicle data so user fills it manually
    const orderData = {
      getNiconInsuranceRes: null,
      autoregVehicleInfo: null,
      vehicleInfo: mergeVehicleInfo(null, null),
      plateNumber,
      productsDetails,
      paymentOption: "PIN",
      insuranceType,
      dataSource: "SKIPPED",
    };

    dispatch(userDataActions.getRenewPapersData(orderData));
    navigate(`/renew/info`);
  };

  const submitOrderHandler = async () => {
    if (isPrivateMotorPlateBlocked) {
      toast.warning(PRIVATE_MOTOR_COMMERCIAL_WARNING, {
        position: "top-left",
        autoClose: 5000,
      });
      return;
    }

    setLoading(true);
    setShowSkipButton(false);

    // Create an AbortController for the vehicle info call
    const controller = new AbortController();
    abortControllerRef.current = controller;

    // Show skip button after 5 seconds
    skipTimerRef.current = setTimeout(() => {
      setShowSkipButton(true);
    }, 2000);

    try {
      //  const makeOrderRes = await FixedAgent.makeManualInsuranceOrder({
      //     plate_no: plateNumber,
      //     payment_option: paymentOption,
      //     pin_type: pinType,
      //     token,
      //   });

      // let getUserInsuranceOnlineDataRes;
      // try {
      //   getUserInsuranceOnlineDataRes =
      //     await FixedAgent.getCustomerInsuranceOnlineData({
      //       plate_no: plateNumber,
      //       token,
      //     });
      // } catch (error) {
      //   console.error(
      //     "Failed to fetch customer insurance online data:",
      //     error?.response?.data?.message
      //   );
      //   getUserInsuranceOnlineDataRes = { data: { data: null } };
      //   console.log(getUserInsuranceOnlineDataRes);
      // }

      // let getUserInsuranceRes;
      // try {
      //   getUserInsuranceRes =
      //     await FixedAgent.getCustomerInsuranceSecondOnlineData({
      //       plate_no: plateNumber,
      //       token,
      //     });
      // } catch (error) {
      //   console.error(
      //     "Failed to fetch customer insurance data:",
      //     error?.response?.data?.message
      //   );
      //   getUserInsuranceRes = { data: { data: null } };
      // }

      const fastPolicyRequest = FixedAgent.getNiconInsuranceData({
        plate_no: plateNumber,
        token,
        signal: controller.signal,
      });
      const autoRegRequest = FixedAgent.getAutoregVehicleInfo({
        plate_no: plateNumber,
        token,
        signal: controller.signal,
      });

      const [fastPolicyResult, autoRegResult] = await Promise.allSettled([
        fastPolicyRequest,
        autoRegRequest,
      ]);

      if (controller.signal.aborted) return;

      const getNiconInsuranceRes =
        fastPolicyResult.status === "fulfilled"
          ? fastPolicyResult.value
          : { data: { fields: null } };

      if (fastPolicyResult.status === "fulfilled") {
        toast.success(`Successful`, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          style: {
            backgroundColor: "#FFFFFF",
            color: "#000000",
          },
        });
      } else {
        console.error(
          "Failed to fetch fast-policy insurance data:",
          fastPolicyResult.reason?.response?.data?.message ||
            fastPolicyResult.reason?.message,
        );
      }

      const autoRegVehicleInfo =
        autoRegResult.status === "fulfilled" ? autoRegResult.value?.data : null;

      if (autoRegResult.status === "rejected") {
        console.warn(
          "AutoReg vehicle lookup failed; continuing with fast-policy data:",
          autoRegResult.reason?.response?.data?.message ||
            autoRegResult.reason?.message,
        );
      }

      const fastPolicyData =
        getNiconInsuranceRes?.data?.data ||
        getNiconInsuranceRes?.data?.fields ||
        null;
      const vehicleInfo = mergeVehicleInfo(
        fastPolicyData,
        autoRegVehicleInfo,
      );
      const fieldSources = new Set(
        Object.values(vehicleInfo.sources).filter(Boolean),
      );
      const primaryDataSource =
        getNiconInsuranceRes?.data?.source || "NIL";
      const dataSource = fieldSources.has("autoreg")
        ? fieldSources.has("fast-policy")
          ? `${primaryDataSource}+AUTOREG`
          : "AUTOREG"
        : primaryDataSource;

      /*
       * Both lookups are intentionally independent. AutoReg enriches only
       * missing vehicle fields and never prevents manual renewal entry.
       */
      const orderData = {
        getNiconInsuranceRes: fastPolicyData,
        autoregVehicleInfo: autoRegVehicleInfo,
        vehicleInfo,
        plateNumber,
        productsDetails,
        paymentOption: "PIN",
        insuranceType,
        dataSource,
      };

      abortControllerRef.current = null;

      // Clear skip timer on success
      if (skipTimerRef.current) {
        clearTimeout(skipTimerRef.current);
        skipTimerRef.current = null;
      }
      setShowSkipButton(false);

      dispatch(userDataActions.getRenewPapersData(orderData));

      navigate(`/renew/info`);
      // navigate(`/history/${makeOrderRes.data.orderID}`);

      setLoading(false);
      return getNiconInsuranceRes;
    } catch (err) {
      // If aborted by skip, don't process error
      if (err?.name === "CanceledError" || err?.code === "ERR_CANCELED") {
        return;
      }
      // Clear skip timer on error
      if (skipTimerRef.current) {
        clearTimeout(skipTimerRef.current);
        skipTimerRef.current = null;
      }
      setShowSkipButton(false);
      setLoading(false);
      if (err?.response?.data?.message === "Plate not found!") {
        addCustomerHandler();
      } else {
        toast.error(err?.response?.data?.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          style: {
            backgroundColor: "#FFFFFF",
            color: "#000000",
          },
        });
      }
    }
  };

  return (
    <div>
      <ToastContainer />

      {modalOpen && (
        <div
          className={styles.modal_overlay}
          onClick={() => setModalOpen(false)}
        >
          <div
            className={styles.modal_card}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              role={isPrivateMotorPlateBlocked ? "alert" : undefined}
              style={{
                backgroundColor: "#fff3cd",
                color: "#856404",
                border: "1px solid #ffeeba",
                borderRadius: "4px",
                padding: "12px 16px",
                marginBottom: "16px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontWeight: "500",
                fontSize: "15px",
              }}
            >
              {isPrivateMotorPlateBlocked ? (
                <>
                  <span
                    style={{ fontSize: "18px" }}
                    aria-label="Caution"
                    role="img"
                  >
                    ⚠️
                  </span>
                  {PRIVATE_MOTOR_COMMERCIAL_WARNING}
                </>
              ) : (
                "Enter Order details below"
              )}
            </div>
            {/* <h1 className={styles.modal_title}></h1> */}
            <p className={styles.modal_description}>Enter Plate Number...</p>
            <input
              className={styles.modal_input}
              type="text"
              value={plateNumber}
              onChange={(e) => setPlateNumber(e.target.value)}
              placeholder="Enter Plate No"
            />

            <p className={styles.modal_description}>Insurance Type</p>
            <select
              className={styles.modal_input}
              value={insuranceType}
              onChange={(e) => setInsuranceType(e.target.value)}
            >
              <option value="">Select Insurance Product</option>
              {/* <option value="CEI">CEI</option> */}
              <option value="NICON">NICON</option>
              {accountType !== "DISTRIBUTOR" && <option value="AG">AG</option>}
              {accountType !== "DISTRIBUTOR" && <option value="AGP">AGP</option>}
              {accountType !== "DISTRIBUTOR" && <option value="FGI">FGI</option>}
              {accountType !== "DISTRIBUTOR" && <option value="FGIP">FGIP</option>}
              {/* <option value="SALAM">SALAM</option> */}
            </select>

            {["AG", "AGP"].includes(insuranceType) && agMeta.loading && (
              <p style={{ marginLeft: "0px" }}>Loading AG form data...</p>
            )}

            {["AG", "AGP"].includes(insuranceType) && agMeta.error && (
              <p style={{ marginLeft: "0px" }}>
                AG form data failed to load. Select AG again to retry.
              </p>
            )}

            {/* <p className={styles.modal_description}>Vehicle Make</p>
            <select
              className={styles.modal_input}
              value={vehicleMake}
              onChange={(e) => setVehicleMake(e.target.value)}
            >
              <option value="">Select Vehicle Make</option>
              <option value="486">KINGO</option>
              <option value="298">Ac Cobra</option>
              <option value="1">Acura</option>
              <option value="126">Admiral</option>
              <option value="276">Agrale</option>
              <option value="306">Akira</option>
              <option value="322">Aktra</option>
              <option value="2">Alfa</option>
              <option value="255">Alsvin</option>
              <option value="394">Amaecom</option>
              <option value="3">AMC</option>
              <option value="380">AMPRI</option>
              <option value="189">Apache</option>
              <option value="361">Aprilia</option>
              <option value="383">Arm</option>
              <option value="430">Armoured</option>
              <option value="270">Aryan</option>
              <option value="64">Ashok Leyland</option>
              <option value="261">Asia</option>
              <option value="209">Aston</option>
              <option value="391">Aston Martin</option>
              <option value="224">Astra</option>
              <option value="293">Atul</option>
              <option value="4">Audi</option>
              <option value="195">Austin</option>
              <option value="311">Autodex</option>
              <option value="302">Avant</option>
              <option value="456">AVATAR</option>
              <option value="344">B-2</option>
              <option value="299">BAIC</option>
              <option value="55">Bajaj</option>
              <option value="446">Baotian</option>
              <option value="163">Basuki</option>
              <option value="115">Baw</option>
              <option value="373">BAWC</option>
              <option value="448">Bazuki</option>
              <option value="112">Bedford</option>
              <option value="450">Belarus</option>
              <option value="152">Bentley</option>
              <option value="329">Berliet</option>
              <option value="330">Berliet Truck</option>
              <option value="5">Bertone</option>
              <option value="437">BikeMaster</option>
              <option value="321">Biyong</option>
              <option value="234">Bluebird</option>
              <option value="6">BMW</option>
              <option value="249">Bocat</option>
              <option value="335">BOMAG</option>
              <option value="400">Bradley</option>
              <option value="388">Braun</option>
              <option value="78">Brilliance</option>
              <option value="7">Buick</option>
              <option value="178">BYD</option>
              <option value="8">Cadillac</option>
              <option value="291">Can am spyder</option>
              <option value="305">Capital</option>
              <option value="350">Cardon</option>
              <option value="113">Cargo</option>
              <option value="183">Carter</option>
              <option value="135">Case</option>
              <option value="123">CAT</option>
              <option value="395">CCIC</option>
              <option value="256">Chagfeng</option>
              <option value="465">Champion</option>
              <option value="399">Champow</option>
              <option value="104">Chana</option>
              <option value="70">Changan</option>
              <option value="262">Changhe</option>
              <option value="396">Changhe Freedom</option>
              <option value="462">Changzhou</option>
              <option value="423">Chanlin</option>
              <option value="381">ChanLine</option>
              <option value="427">Cherokee</option>
              <option value="124">Cherry</option>
              <option value="9">Chevrolet</option>
              <option value="403">chongqing</option>
              <option value="10">Chrysler</option>
              <option value="417">CHTC</option>
              <option value="425">Chuangxin</option>
              <option value="196">Chunzhou</option>
              <option value="245">Cimc</option>
              <option value="271">Cisterna</option>
              <option value="101">Citroen</option>
              <option value="352">CLAAS</option>
              <option value="441">Classic</option>
              <option value="375">CMC</option>
              <option value="192">Commander</option>
              <option value="408">Compact</option>
              <option value="451">Covette</option>
              <option value="143">Crane</option>
              <option value="439">Cummins</option>
              <option value="405">Cushman</option>
              <option value="162">Dacia</option>
              <option value="239">Dadi</option>
              <option value="11">Daewoo</option>
              <option value="66">DAF</option>
              <option value="12">Daihatsu</option>
              <option value="445">Dasuki</option>
              <option value="119">Datsun</option>
              <option value="297">Dayang</option>
              <option value="91">Daylong</option>
              <option value="193">Dayun</option>
              <option value="339">DE-DAMAK</option>
              <option value="281">Degab</option>
              <option value="346">Dennis</option>
              <option value="402">Denstar</option>
              <option value="333">Derbi</option>
              <option value="367">DETOMASO</option>
              <option value="137">Dfac</option>
              <option value="447">DFM</option>
              <option value="227">DFSK</option>
              <option value="364">Diamond Reo</option>
              <option value="382">Dieci</option>
              <option value="13">Dodge</option>
              <option value="208">Dongfeng</option>
              <option value="275">Doosan</option>
              <option value="231">Doosan Infracore</option>
              <option value="358">DR</option>
              <option value="296">Dragon</option>
              <option value="466">DS</option>
              <option value="223">Ducati</option>
              <option value="371">DULEVO</option>
              <option value="248">Dumec</option>
              <option value="228">Dynapac</option>
              <option value="14">Eagle</option>
              <option value="469">EBIKE</option>
              <option value="167">Eicher</option>
              <option value="369">EMI</option>
              <option value="180">ERF</option>
              <option value="431">ERRAUD</option>
              <option value="349">Eval</option>
              <option value="420">Fabtol</option>
              <option value="286">Famtrac</option>
              <option value="418">Farmax</option>
              <option value="230">Faun</option>
              <option value="157">FAW</option>
              <option value="202">Fenco</option>
              <option value="459">FENGXING</option>
              <option value="164">Ferari</option>
              <option value="169">Ferguson Massey</option>
              <option value="73">FIAT</option>
              <option value="331">Figo</option>
              <option value="288">Fiori</option>
              <option value="251">Fire</option>
              <option value="292">Foday</option>
              <option value="203">Foden</option>
              <option value="171">Force</option>
              <option value="15">Ford</option>
              <option value="120">Forland</option>
              <option value="85">Foton</option>
              <option value="61">Frajend</option>
              <option value="125">Freightliner</option>
              <option value="379">FUJIA</option>
              <option value="82">GAC</option>
              <option value="343">Galaxy</option>
              <option value="436">Gallant</option>
              <option value="277">Gazelle</option>
              <option value="74">Geely</option>
              <option value="236">Genie</option>
              <option value="428">Genlyon</option>
              <option value="16">Geo</option>
              <option value="17">GMC</option>
              <option value="424">GME</option>
              <option value="323">Go Well</option>
              <option value="110">GOLDEN DRAGON</option>
              <option value="133">Gonow</option>
              <option value="307">GP Mobile</option>
              <option value="63">Grand</option>
              <option value="99">Great Wall</option>
              <option value="138">Grove</option>
              <option value="410">GUZZI</option>
              <option value="304">Hafei</option>
              <option value="93">Haima</option>
              <option value="407">Hako</option>
              <option value="312">Haojin</option>
              <option value="100">Haojue</option>
              <option value="301">Harley</option>
              <option value="218">HAWTAI</option>
              <option value="452">Hero</option>
              <option value="134">Hiab</option>
              <option value="155">Higer</option>
              <option value="433">HIJOY</option>
              <option value="197">Hino</option>
              <option value="184">Hitachi</option>
              <option value="263">Holden</option>
              <option value="253">Holland Fatagri</option>
              <option value="18">Honda</option>
              <option value="497">Honda-Motocycle</option>
              <option value="205">Hongyang</option>
              <option value="490">Hongzhou</option>
              <option value="98">Hover</option>
              <option value="105">Howo</option>
              <option value="260">Huanghai</option>
              <option value="19">Hummer</option>
              <option value="458">Hunter</option>
              <option value="229">Hyosung</option>
              <option value="269">Hyster</option>
              <option value="20">Hyundai</option>
              <option value="168">Hyva</option>
              <option value="226">IHI</option>
              <option value="109">Indian</option>
              <option value="21">Infiniti</option>
              <option value="432">Ingersoll-Rand</option>
              <option value="81">Innoson</option>
              <option value="142">International</option>
              <option value="273">Irizar</option>
              <option value="22">Isuzu</option>
              <option value="56">Iveco</option>
              <option value="357">IX</option>
              <option value="108">JAC</option>
              <option value="23">Jaguar</option>
              <option value="274">Jcb</option>
              <option value="24">Jeep</option>
              <option value="435">Jet</option>
              <option value="460">Jetour</option>
              <option value="200">Jianshe</option>
              <option value="84">Jinbei</option>
              <option value="118">Jincheng</option>
              <option value="387">Jiuxing</option>
              <option value="172">JMC</option>
              <option value="282">John</option>
              <option value="287">Jonway</option>
              <option value="146">Joylong</option>
              <option value="491">Juncheng</option>
              <option value="463">KAISA</option>
              <option value="207">Kalmar</option>
              <option value="94">Kama</option>
              <option value="426">KARY-GO</option>
              <option value="313">Kasan</option>
              <option value="90">Kasea</option>
              <option value="365">Kavaki</option>
              <option value="95">Kawasaki</option>
              <option value="284">Kayak</option>
              <option value="201">Kc Sanya</option>
              <option value="372">Keeway</option>
              <option value="340">KEIHIN MDGS</option>
              <option value="181">Keke</option>
              <option value="165">Kenworth</option>
              <option value="156">Keystone</option>
              <option value="25">Kia</option>
              <option value="80">King</option>
              <option value="443">King Long</option>
              <option value="210">Kingkan</option>
              <option value="413">kinglong</option>
              <option value="79">Kingston</option>
              <option value="235">Kobelco</option>
              <option value="300">Korando</option>
              <option value="222">KTM</option>
              <option value="140">KYMCO</option>
              <option value="370">Kymstone</option>
              <option value="406">LADA</option>
              <option value="495">LAMBERT</option>
              <option value="266">Lamborghini</option>
              <option value="161">Lancia</option>
              <option value="26">Land Rover</option>
              <option value="216">LANDINI</option>
              <option value="214">LANDINI GLOBALFARM</option>
              <option value="215">LANDINI LP</option>
              <option value="198">Landwind</option>
              <option value="213">LAN-P</option>
              <option value="187">LDV</option>
              <option value="27">Lexus</option>
              <option value="97">Leyland</option>
              <option value="71">Liberty</option>
              <option value="412">LIEBAO</option>
              <option value="186">Liebherr</option>
              <option value="106">Lifan</option>
              <option value="28">Lincoln</option>
              <option value="257">Linde R20 Forklift</option>
              <option value="250">LINDE R20 S FORKLIFT</option>
              <option value="414">Lingkin</option>
              <option value="457">Little</option>
              <option value="324">Loncin</option>
              <option value="419">LTI</option>
              <option value="258">M/BENZ CLS 500</option>
              <option value="57">MAC</option>
              <option value="72">MACK</option>
              <option value="442">MAG INTERNATIONAL</option>
              <option value="318">Magirus</option>
              <option value="268">MAHINDRA</option>
              <option value="103">Make</option>
              <option value="332">Malossi</option>
              <option value="65">MAN</option>
              <option value="206">Manitou</option>
              <option value="355">Marcopolo S.A</option>
              <option value="422">Mars</option>
              <option value="221">Maruti</option>
              <option value="182">Maserati</option>
              <option value="409">Matrix 100</option>
              <option value="160">Maxus</option>
              <option value="316">MayBach</option>
              <option value="29">Mazda</option>
              <option value="389">McLaren</option>
              <option value="351">MCV</option>
              <option value="319">MDGS</option>
              <option value="149">MEIYA</option>
              <option value="30">Mercedes-Benz</option>
              <option value="31">Mercury</option>
              <option value="32">Merkur</option>
              <option value="283">Merlo</option>
              <option value="128">MG</option>
              <option value="289">MHRX</option>
              <option value="374">Midas</option>
              <option value="468">MIKANO</option>
              <option value="33">MINI</option>
              <option value="34">Mitsubishi</option>
              <option value="129">MOBITI</option>
              <option value="303">Moto</option>
              <option value="144">Motobi</option>
              <option value="267">MOTORCYCLE</option>
              <option value="492">Motorcycle</option>
              <option value="310">Mudan</option>
              <option value="454">Muoner</option>
              <option value="334">MV</option>
              <option value="148">NANFANG</option>
              <option value="141">NASARA</option>
              <option value="150">Navister International</option>
              <option value="254">Neoplan</option>
              <option value="482">NEW FIRE</option>
              <option value="280">Nippon</option>
              <option value="35">Nissan</option>
              <option value="453">Nord</option>
              <option value="294">Norge</option>
              <option value="122">NTM</option>
              <option value="86">Octavia</option>
              <option value="92">OGBUAWA</option>
              <option value="36">Oldsmobile</option>
              <option value="53">Opel</option>
              <option value="220">Pegaso</option>
              <option value="377">PERFORMER</option>
              <option value="151">Peterbilt</option>
              <option value="37">Peugeot</option>
              <option value="59">Piaggio</option>
              <option value="368">PICCASO</option>
              <option value="38">Pininfarina</option>
              <option value="309">Pioneer</option>
              <option value="498">Plagio</option>
              <option value="39">Plymouth</option>
              <option value="401">Polaris</option>
              <option value="179">Polarsun</option>
              <option value="40">Pontiac</option>
              <option value="41">Porsche</option>
              <option value="237">Powerplus</option>
              <option value="416">Preet</option>
              <option value="429">Premier</option>
              <option value="145">President</option>
              <option value="362">Prezda</option>
              <option value="185">Proton</option>
              <option value="211">Pulsar</option>
              <option value="130">QINGQI</option>
              <option value="68">Qlink</option>
              <option value="188">Quad</option>
              <option value="464">RAMBLER AMBASSADOR</option>
              <option value="67">Range</option>
              <option value="42">Renault</option>
              <option value="194">Rexton</option>
              <option value="353">Rhino</option>
              <option value="404">Rico</option>
              <option value="444">RKV</option>
              <option value="191">Robinson</option>
              <option value="153">Rocky</option>
              <option value="75">ROLLS-ROYCE</option>
              <option value="455">RONGXING</option>
              <option value="166">Rosenbauer</option>
              <option value="62">Rover</option>
              <option value="114">Royal</option>
              <option value="484">RUMION</option>
              <option value="43">Saab</option>
              <option value="398">SAIC</option>
              <option value="347">Saipa</option>
              <option value="173">Samsung</option>
              <option value="212">Sany</option>
              <option value="199">Sanyang</option>
              <option value="44">Saturn</option>
              <option value="87">Savana</option>
              <option value="77">Scania</option>
              <option value="127">Scion</option>
              <option value="58">SEAT</option>
              <option value="102">Seddon</option>
              <option value="488">SEM</option>
              <option value="345">Sento</option>
              <option value="233">Shacman</option>
              <option value="190">Shanghai</option>
              <option value="219">Shelby</option>
              <option value="242">SHIFENG</option>
              <option value="158">Shineray</option>
              <option value="440">Shiroro</option>
              <option value="246">Shovel</option>
              <option value="232">Shuanghuan</option>
              <option value="217">Shuang-huan</option>
              <option value="359">Silfox</option>
              <option value="88">Simba</option>
              <option value="117">Sino</option>
              <option value="60">sinoki</option>
              <option value="52">Skoda</option>
              <option value="121">Skygo</option>
              <option value="176">SMA</option>
              <option value="243">Smart</option>
              <option value="461">Sonlink</option>
              <option value="496">SONLINK</option>
              <option value="393">Spartan</option>
              <option value="363">SsangYong</option>
              <option value="116">Ssanyoung</option>
              <option value="177">Stallion</option>
              <option value="45">Sterling</option>
              <option value="107">STEYR</option>
              <option value="46">Subaru</option>
              <option value="147">Sukida</option>
              <option value="139">Super</option>
              <option value="47">Suzuki</option>
              <option value="360">Swaraj</option>
              <option value="376">SYM</option>
              <option value="354">TAK PERFORMER</option>
              <option value="493">Target</option>
              <option value="320">Tarsung</option>
              <option value="83">Tata</option>
              <option value="252">Taylor</option>
              <option value="342">TEC</option>
              <option value="265">Terberg</option>
              <option value="136">Terex</option>
              <option value="131">Terrain</option>
              <option value="397">Tesla</option>
              <option value="467">test</option>
              <option value="411">TEZRAFTAAR</option>
              <option value="384">Thomas</option>
              <option value="449">Tiffin</option>
              <option value="238">T-King</option>
              <option value="485">T-KING</option>
              <option value="378">Tongjiafu</option>
              <option value="314">TopStar</option>
              <option value="154">Torino</option>
              <option value="48">Toyota</option>
              <option value="241">Toyota hiace pick/up</option>
              <option value="315">Tractor</option>
              <option value="278">Triumph</option>
              <option value="438">Trumpchi</option>
              <option value="317">Tuktuk</option>
              <option value="76">TVS</option>
              <option value="341">TVT</option>
              <option value="290">Twinco</option>
              <option value="264">UAZ</option>
              <option value="338">Ursus</option>
              <option value="415">UVA</option>
              <option value="240">vanhool</option>
              <option value="132">Vauxhall</option>
              <option value="390">VDL Bova</option>
              <option value="325">Vespa</option>
              <option value="386">Victory</option>
              <option value="225">Vietz</option>
              <option value="327">Vogue</option>
              <option value="295">Volat</option>
              <option value="49">Volkswagen</option>
              <option value="50">Volvo</option>
              <option value="366">Wanhoo</option>
              <option value="326">Western Star</option>
              <option value="336">Wheel</option>
              <option value="489">WHEEL LOADER</option>
              <option value="392">White Knuckle</option>
              <option value="385">Wodeli</option>
              <option value="175">Wrangler</option>
              <option value="170">Wuling</option>
              <option value="285">Wuyang</option>
              <option value="483">XCMG </option>
              <option value="328">XFMCO</option>
              <option value="244">xinkai</option>
              <option value="434">Yakeda</option>
              <option value="356">Yale</option>
              <option value="89">Yamaha</option>
              <option value="308">Yamasaki</option>
              <option value="174">Yaxing</option>
              <option value="421">Yochi</option>
              <option value="259">Yorobo Apsonic</option>
              <option value="96">YUEJIN</option>
              <option value="51">Yugo</option>
              <option value="159">Yutong</option>
              <option value="204">Zahav</option>
              <option value="337">zarsung</option>
              <option value="494">Zhejiang</option>
              <option value="247">ZHONGTONG</option>
              <option value="54">Zhongxing</option>
              <option value="348">ZNA-RICH</option>
              <option value="279">Zonsheng</option>
              <option value="272">Zoomlion</option>
              <option value="69">Zotye</option>
              <option value="487">ZOYTE</option>
              <option value="111">Zx Auto</option>
            </select>

            <p className={styles.modal_description}>Vehicle Model</p>
            <select
              className={styles.modal_input}
              value={vehicleModelCode}
              onChange={(e) => setVehicleModelCode(e.target.value)}
            >
              <option value="">Select Model</option>
              {vehicleModel?.map((option) => (
                <option
                  key={option.vehicleModelId}
                  value={option.vehicleModelId}
                >
                  {option.modelName}
                </option>
              ))}
            </select>

            <p className={styles.modal_description}>Vehicle Year</p>
            <select
              className={styles.modal_input}
              value={year}
              onChange={(e) => setYear(e.target.value)}
            >
              <option value="">Select Model</option>
              {Array.from({ length: 36 }, (_, i) => 2025 - i).map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>

            <p className={styles.modal_description}>Vehicle Color</p>
            <select
              className={styles.modal_input}
              value={vehicleColorCode}
              onChange={(e) => setVehicleColorCode(e.target.value)}
            >
              <option value="">Select Color</option>
              {vehicleColor?.map((option) => (
                <option
                  key={option.vehicleColorId}
                  value={option.vehicleColorId}
                >
                  {option.colorName}
                </option>
              ))}
            </select> */}

            {/* {paymentOption === "PIN" && (
              <p className={styles.modal_description}>PIN Type</p>
            )}
            {paymentOption === "PIN" && (
              <select
                className={styles.modal_input}
                value={pinType}
                onChange={(e) => setPinType(e.target.value)}
              >
                <option value="">Select Export Option</option>
                <option value="IEI">IEI</option>
                <option value="CEI">CEI</option>
                 <option value="NICON">NICON</option>
              </select>
            )} */}

            <p style={{ marginLeft: "0px" }}>{updateMessage}</p>

            {insuranceType && plateNumber && (
              <button
                className={styles.modal_button}
                onClick={() => submitOrderHandler()}
                disabled={
                  loading ||
                  isPrivateMotorPlateBlocked ||
                  (["AG", "AGP"].includes(insuranceType) &&
                    (agMeta.loading || !agMeta.data))
                }
              >
                {loading ||
                (["AG", "AGP"].includes(insuranceType) && agMeta.loading)
                  ? `Loading...`
                  : `Proceed`}
              </button>
            )}

            {showSkipButton && loading && (
              <button
                className={styles.skip_autofill_button}
                onClick={handleSkipAutofill}
                type="button"
              >
                Skip Autofill
              </button>
            )}
          </div>
        </div>
      )}

      <div className="menu" onClick={() => props.setShowMenu(false)}>
        {props.showMenu && <Menu setShowMenu={props.setShowMenu} />}
      </div>

      <Navbar title="Renew" setShowMenu={props.setShowMenu} />
      
      <div className={styles.pageBody}>
        <h1 className={styles.headerTitle}>Select Vehicle Type</h1>
        <p className={styles.headerSubtitle}>Choose the type of vehicle you want to renew insurance for.</p>

        <div className={styles.cards_wrapper}>
          {[
            {
              id: 1,
              title: "Private Motor",
              subtitle: "Cars, SUVs and private vehicles",
              badge: "Third Party Insurance",
              price: "15,000",
              apiName: "PrivateMotor",
              iconBg: "#EBF3FC",
              iconColor: "#4A90E2",
              iconSvg: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5H6.5c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 7h10.28l1.08 3.11H5.77L6.85 7zM19 17H5v-5h14v5z"/>
                  <circle cx="7.5" cy="14.5" r="1.5"/><circle cx="16.5" cy="14.5" r="1.5"/>
                </svg>
              )
            },
            {
              id: 2,
              title: "Commercial Vehicle",
              subtitle: "Buses, taxis, and commercial vehicles",
              badge: "Third Party Insurance",
              price: "20,000",
              apiName: "Commercial",
              iconBg: "#E9F7EF",
              iconColor: "#27AE60",
              iconSvg: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
                </svg>
              )
            },
            {
              id: 3,
              title: "Motorcycle (Bike)",
              subtitle: "Motorcycles and scooters",
              badge: "Third Party Insurance",
              price: "3,000",
              apiName: "MotorCycle",
              iconBg: "#F4EBFC",
              iconColor: "#9B51E0",
              iconSvg: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.44 9.03L15.41 5H11v2h3.59l2 2H5c-2.8 0-5 2.2-5 5s2.2 5 5 5c2.46 0 4.45-1.69 4.9-4h4.2c.45 2.31 2.44 4 4.9 4 2.8 0 5-2.2 5-5 0-2.12-1.33-3.93-3.16-4.71zM5 17c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm14 0c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"/>
                </svg>
              )
            },
            {
              id: 4,
              title: "Tricycle (Keke)",
              subtitle: "Tricycles and auto-rickshaws",
              badge: "Third Party Insurance",
              price: "5,000",
              apiName: "TriCycle",
              iconBg: "#FEF5EB",
              iconColor: "#F2994A",
              iconSvg: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.5 13H17V9.5c0-1.93-1.57-3.5-3.5-3.5H9c-1.93 0-3.5 1.57-3.5 3.5V13H4c-1.1 0-2 .9-2 2v3h2c0 1.66 1.34 3 3 3s3-1.34 3-3h8c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-3c0-1.1-.9-2-2-2zM7.5 18c-.83 0-1.5-.67-1.5-1.5S6.67 15 7.5 15 9 15.67 9 16.5 8.33 18 7.5 18zm5.5-5H7V9.5C7 8.67 7.67 8 8.5 8h4c.83 0 1.5.67 1.5 1.5V13zm3.5 5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
                </svg>
              )
            },
            {
              id: 5,
              title: "Truck / Trailer",
              subtitle: "Trucks, trailers and heavy vehicles",
              badge: "Third Party Insurance",
              price: "100,000",
              apiName: "Truck",
              iconBg: "#EAECEE",
              iconColor: "#34495E",
              iconSvg: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 8h-3V4H7v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM7 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm10 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
                </svg>
              )
            }
          ].map(vehicle => (
            <div 
              key={vehicle.id} 
              className={styles.vehicleCard}
              onClick={() => {
                const product = NICON_PRODUCT_CATALOGUE[vehicle.apiName];
                handleRenew(product ? { ...product } : {
                  id: null,
                  product_name: `${vehicle.title} - Third Party Insurance`,
                  product_category: vehicle.apiName,
                  pin_type: vehicle.apiName,
                  nicon_category_id: null,
                  nicon_category_name: null,
                  cei_policy_type: vehicle.apiName,
                  product_type: "Third-Party",
                  product_price: parseInt(vehicle.price.replace(',', ''))
                });
              }}
            >
              <div className={styles.iconBox} style={{ backgroundColor: vehicle.iconBg, color: vehicle.iconColor }}>
                {vehicle.iconSvg}
              </div>
              
              <div className={styles.cardContent}>
                <h3 className={styles.cardTitle}>{vehicle.title}</h3>
                <p className={styles.cardSubtitle}>{vehicle.subtitle}</p>
                <div className={styles.badge} style={{ backgroundColor: vehicle.iconBg, color: vehicle.iconColor }}>
                  {vehicle.badge}
                </div>
              </div>

              <div className={styles.cardRight}>
                <div className={styles.priceContainer}>
                  <span className={styles.startingFrom}>Starting from</span>
                  <span className={styles.price} style={{ color: vehicle.iconColor }}>
                    ₦{vehicle.price}
                  </span>
                </div>
                <div className={styles.arrowIcon}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className={styles.infoAlert}>
          <div className={styles.infoIcon}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/>
            </svg>
          </div>
          <div className={styles.infoContent}>
            <h4 className={styles.infoTitle}>All policies are Third Party Insurance</h4>
            <p className={styles.infoSubtitle}>Fast, reliable and accepted nationwide.</p>
          </div>
          <div className={styles.shieldOutline}>
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.3">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            </svg>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Renew;
